import {ref} from 'vue'

const layout = ref('RB')
export default layout 
export { layout } 